import React, { Component } from "react";
import {
    PageHeader, Spin, Card, Row, Col, Tag, message, Collapse, Progress
} from "antd";
import { EyeOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { ButtonItem } from "../../../../Components/Items";

moment.locale("es");

const { Panel } = Collapse;

const ESTADO_CONTEO = { 0: "Cancelado", 1: "Activo", 2: "En revisión", 3: "Finalizado" };
const ESTADO_ORDEN  = { 0: "Cancelada", 1: "Pendiente", 2: "Contada", 3: "Aprobada" };
const ESTADO_ORDEN_COLOR = { 0: "red", 1: "default", 2: "blue", 3: "green" };

const TH = (extra = {}) => ({
    background: "#e6f7fa", color: "#006d75", fontWeight: 600,
    padding: "8px 10px", whiteSpace: "nowrap", textAlign: "right", ...extra,
});
const TD = (extra = {}) => ({
    padding: "7px 10px", verticalAlign: "middle", textAlign: "right", ...extra,
});

class VerConteo extends Component {
    state = {
        loading: false,
        conteo: null,
        ordenes: [],
        ordenesDetalle: {},   // { [ordenId]: { loading, insumos, maxIntento } }
        id: this.props.match.params.id,
    };

    componentDidMount() {
        this.consultarDetalle();
    }

    async consultarDetalle() {
        this.setState({ loading: true });
        try {
            const res = await axios.post(
                "conteos/selectDetalleConteo",
                { empresaId: this.props.empresaId, conteoId: this.state.id },
                { headers: this.props.headersToken }
            );
            if (res.data.success === 2) {
                this.setState({ conteo: res.data.conteo, ordenes: res.data.ordenes || [] });
            } else {
                message.error("No se encontró el conteo");
            }
        } catch {
            message.error("Error de conexión");
        }
        this.setState({ loading: false });
    }

    async cargarOrden(ordenId) {
        const { ordenesDetalle } = this.state;
        if (ordenesDetalle[ordenId]) return; // ya cargada

        this.setState(prev => ({
            ordenesDetalle: { ...prev.ordenesDetalle, [ordenId]: { loading: true, insumos: [], maxIntento: 0 } },
        }));
        try {
            const res = await axios.post(
                "ordenesDeConteo/selectOrdenDeConteo",
                { empresaId: this.props.empresaId, ordenDeConteoId: ordenId },
                { headers: this.props.headersToken }
            );
            if (res.data.success === 2) {
                const insumos = res.data.orden?.insumos || [];
                const maxIntento = insumos.reduce((m, i) => Math.max(m, i.conteos?.length || 0), 0);
                this.setState(prev => ({
                    ordenesDetalle: {
                        ...prev.ordenesDetalle,
                        [ordenId]: { loading: false, insumos, maxIntento },
                    },
                }));
            } else {
                message.error("No se pudo cargar la orden");
                this.setState(prev => ({
                    ordenesDetalle: { ...prev.ordenesDetalle, [ordenId]: { loading: false, insumos: [], maxIntento: 0 } },
                }));
            }
        } catch {
            message.error("Error de conexión");
            this.setState(prev => ({
                ordenesDetalle: { ...prev.ordenesDetalle, [ordenId]: { loading: false, insumos: [], maxIntento: 0 } },
            }));
        }
    }

    atras() {
        this.props.history.goBack();
    }

    renderTablaOrden(ordenId) {
        const det = this.state.ordenesDetalle[ordenId];
        if (!det) return null;
        if (det.loading) return <Spin style={{ display: "block", margin: "20px auto" }} />;

        const { insumos, maxIntento } = det;
        if (!insumos.length) {
            return <p style={{ color: "#8c8c8c", padding: 12 }}>Sin insumos registrados.</p>;
        }

        // La columna aparece solo si algun insumo de la orden tiene codigo de barras capturado,
        // para no ensanchar la tabla con una columna de puros guiones.
        const mostrarCodigoBarras = insumos.some((i) => !!i.codigoBarras);

        return (
            <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                    <thead>
                        <tr>
                            <th className="th-border" style={TH({ textAlign: "left", width: "25%" })}>Insumo</th>
                            {mostrarCodigoBarras && (
                                <th className="th-border" style={TH({ textAlign: "left", width: "13%" })}>Cód. barras</th>
                            )}
                            {Array.from({ length: maxIntento }, (_, i) => (
                                <th key={i} className="th-border" style={TH({ width: "10%" })}>
                                    {i === 0 ? "Conteo 1" : `Reconteo ${i}`}
                                </th>
                            ))}
                            <th className="th-border" style={TH({ width: "9%" })}>Snapshot</th>
                            <th className="th-border" style={TH({ width: "9%" })}>Dif. final</th>
                            <th className="th-border" style={TH({ width: "8%" })}>% Dif.</th>
                            <th className="th-border" style={TH({ textAlign: "center", width: "10%" })}>Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {insumos.map((item, idx) => {
                            const ultimo = item.conteos?.[item.conteos.length - 1];
                            const diff = item.resolucion?.diferenciaFinal ?? ultimo?.diferenciaVsSnapshot;
                            const snapshot = item.resolucion?.snapshotFinal;
                            const pctDiff = diff != null && snapshot != null && snapshot !== 0
                                ? ((diff / snapshot) * 100).toFixed(2) : null;
                            const rowBg = item.conteos?.length > 0
                                ? (diff === 0 ? "#f6ffed" : diff != null ? "#fff1f0" : "#fffbe6")
                                : (idx % 2 === 0 ? "#fafafa" : "#ffffff");
                            const diffColor = diff === 0 ? "#52c41a" : diff != null ? "#f5222d" : undefined;

                            let estadoInsumo = "Pendiente";
                            let estadoColor = "default";
                            if (item.resolucion?.cantidadFinal != null) { estadoInsumo = "Resuelto"; estadoColor = "green"; }
                            else if (item.requiereReconteo) { estadoInsumo = "Reconteo"; estadoColor = "orange"; }
                            else if (item.conteos?.length > 0) { estadoInsumo = "Contado"; estadoColor = "blue"; }

                            return (
                                <tr key={idx} style={{ background: rowBg }}>
                                    <td className="td-border" style={TD({ textAlign: "left" })}>{item.nombre || "—"}</td>
                                    {mostrarCodigoBarras && (
                                        <td className="td-border" style={TD({ textAlign: "left", color: "#595959", fontFamily: "monospace" })}>
                                            {item.codigoBarras || "—"}
                                        </td>
                                    )}
                                    {Array.from({ length: maxIntento }, (_, i) => (
                                        <td key={i} className="td-border" style={TD({ color: "#595959" })}>
                                            {item.conteos?.[i]?.cantidadContada ?? "—"}
                                        </td>
                                    ))}
                                    <td className="td-border" style={TD()}>{snapshot ?? "—"}</td>
                                    <td className="td-border" style={TD({ fontWeight: 600, color: diffColor })}>
                                        {diff != null ? (diff > 0 ? `+${diff}` : String(diff)) : "—"}
                                    </td>
                                    <td className="td-border" style={TD({ fontWeight: 600, color: diffColor })}>
                                        {pctDiff !== null ? `${parseFloat(pctDiff) > 0 ? "+" : ""}${pctDiff}%` : "—"}
                                    </td>
                                    <td className="td-border" style={TD({ textAlign: "center" })}>
                                        <Tag color={estadoColor}>{estadoInsumo}</Tag>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        const { loading, conteo, ordenes } = this.state;

        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title={conteo ? `Ver Conteo: ${conteo.nombre}` : "Ver Conteo"}
                    tags={conteo ? <Tag color={conteo.estado === 3 ? "green" : conteo.estado === 0 ? "red" : "blue"}>{ESTADO_CONTEO[conteo.estado] ?? "—"}</Tag> : null}
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                />

                <div className="card-background">
                    <Spin spinning={loading}>
                        {conteo && (
                            <Card
                                style={{ marginBottom: 16, borderRadius: 8, border: "1px solid #d9f2f5", background: "#f0f9fa" }}
                                bodyStyle={{ padding: "12px 18px" }}
                            >
                                <Row gutter={[24, 8]}>
                                    {conteo.proyectoNombre && (
                                        <Col>
                                            <div style={{ fontSize: 11, color: "#8c8c8c" }}>Proyecto</div>
                                            <div style={{ fontSize: 13 }}>{conteo.proyectoNombre}</div>
                                        </Col>
                                    )}
                                    {conteo.supervisorNombre && (
                                        <Col>
                                            <div style={{ fontSize: 11, color: "#8c8c8c" }}>Supervisor</div>
                                            <div style={{ fontSize: 13 }}>{conteo.supervisorNombre}</div>
                                        </Col>
                                    )}
                                    <Col>
                                        <div style={{ fontSize: 11, color: "#8c8c8c" }}>Órdenes</div>
                                        <div style={{ fontSize: 13, fontWeight: 600 }}>{ordenes.length}</div>
                                    </Col>
                                    <Col>
                                        <div style={{ fontSize: 11, color: "#8c8c8c" }}>Aprobadas</div>
                                        <div style={{ fontSize: 13, fontWeight: 600, color: "#52c41a" }}>
                                            {ordenes.filter(o => o.estado === 3).length}
                                        </div>
                                    </Col>
                                </Row>
                            </Card>
                        )}

                        <Collapse
                            accordion={false}
                            onChange={(keys) => {
                                const key = Array.isArray(keys) ? keys[keys.length - 1] : keys;
                                if (key) this.cargarOrden(key);
                            }}
                        >
                            {ordenes.map((orden) => {
                                const pct = orden.totalInsumos > 0
                                    ? Math.round(((orden.insumosContados ?? 0) / orden.totalInsumos) * 100)
                                    : 0;
                                const header = (
                                    <Row align="middle" gutter={16} style={{ width: "100%" }}>
                                        <Col flex="auto">
                                            <span style={{ fontWeight: 600, marginRight: 10 }}>
                                                {orden.serieNumero || orden._id}
                                            </span>
                                            <span style={{ color: "#8c8c8c", fontSize: 12 }}>
                                                {orden.responsableNombre || ""}
                                            </span>
                                        </Col>
                                        <Col style={{ minWidth: 130 }}>
                                            <Progress
                                                percent={pct}
                                                size="small"
                                                strokeColor={pct === 100 ? "#52c41a" : "#00BFD6"}
                                                style={{ marginBottom: 0 }}
                                            />
                                        </Col>
                                        <Col>
                                            <Tag color={ESTADO_ORDEN_COLOR[orden.estado]}>
                                                {ESTADO_ORDEN[orden.estado] ?? "—"}
                                            </Tag>
                                        </Col>
                                        <Col>
                                            <span style={{ color: "#8c8c8c", fontSize: 11 }}>
                                                {orden.insumosContados ?? 0}/{orden.totalInsumos ?? 0} insumos
                                            </span>
                                        </Col>
                                        <Col onClick={e => e.stopPropagation()}>
                                            <ButtonItem
                                                type="primary"
                                                size="small"
                                                icon={<EyeOutlined />}
                                                onClick={() => this.props.history.push(`/panel/verOrdenDeConteo/${orden._id}`)}
                                            >
                                                Ver
                                            </ButtonItem>
                                        </Col>
                                    </Row>
                                );

                                return (
                                    <Panel key={orden._id} header={header}>
                                        {this.renderTablaOrden(orden._id)}
                                    </Panel>
                                );
                            })}
                        </Collapse>

                        {!loading && ordenes.length === 0 && (
                            <p style={{ color: "#8c8c8c", textAlign: "center", marginTop: 24 }}>
                                Este conteo no tiene órdenes registradas.
                            </p>
                        )}
                    </Spin>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(VerConteo);
